import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";
import ronImg from "@/assets/team-ron.webp";
import ellenImg from "@/assets/team-ellen-sharp.webp";

const FoundersStory = () => {
  const { lang, t } = useI18n();
  const f = t.founders;

  return (
    <section id="who" className="py-16 md:py-24 bg-brand-black border-t border-white/5">
      <div className="container mx-auto px-6 max-w-[960px]">
        {/* Section header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-12 md:mb-16"
        >
          <div className="section-label mb-3">{f.label[lang]}</div>
          <h2 className="font-display text-3xl md:text-5xl text-white leading-[1.1] max-w-[720px]">
            {f.h2[lang]}
          </h2>
        </motion.div>

        {/* Ellen — primary founder card */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="grid md:grid-cols-[200px_1fr] gap-8 md:gap-12 items-start"
        >
          <div className="relative">
            <div className="aspect-[3/4] w-full max-w-[200px] rounded-sm overflow-hidden border border-brand-blue/30">
              <img
                src={ellenImg}
                alt="Portret van Ellen Verhoeven, founder A-WAVE"
                width={400}
                height={534}
                loading="lazy"
                className="w-full h-full object-cover object-top"
              />
          </div>

          </div>

          <div>
            <div className="text-[10px] font-semibold uppercase tracking-[0.22em] text-brand-blue mb-2">
              {(f.ellen as any).role[lang]}
            </div>
            <div className="font-display text-2xl md:text-3xl text-white mb-5 leading-tight">
              {f.ellen.kicker[lang]}
            </div>
            <blockquote className="font-display text-lg md:text-xl text-white leading-[1.4] mb-6 border-l-2 border-brand-blue pl-4 md:pl-5">
              &ldquo;{f.ellen.quote[lang]}&rdquo;
            </blockquote>
            <p className="font-light text-[14.5px] md:text-[15px] leading-[1.75] text-white/80">
              {f.ellen.body[lang]}
            </p>
          </div>
        </motion.div>

        {/* Ron — partner card, smaller */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="mt-14 md:mt-20 grid md:grid-cols-[120px_1fr] gap-5 md:gap-8 items-start p-6 md:p-7 bg-brand-off/40 border border-white/5 rounded-sm"
        >
          <div className="w-24 h-24 md:w-[120px] md:h-[120px] rounded-sm overflow-hidden border border-brand-blue/20 shrink-0">
            <img
              src={ronImg}
              alt="Portret van Ron van de Weerd, technisch partner"
              width={240}
              height={240}
              loading="lazy"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <div className="text-[10px] font-semibold uppercase tracking-[0.22em] text-brand-blue mb-2">
              {(f.ron as any).role[lang]}
            </div>
            <div className="font-display text-xl text-white mb-3 leading-tight">
              {f.ron.kicker[lang]}
            </div>
            <p className="font-light text-[14px] leading-[1.7] text-white/75">
              {f.ron.body[lang]}
            </p>
          </div>
        </motion.div>

        {/* Together — short closer */}
        <motion.p
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15 }}
          className="mt-8 font-display text-lg md:text-xl text-white/90 leading-[1.5] border-l-2 border-brand-blue pl-4 md:pl-5"
        >
          {f.together.body[lang]}
        </motion.p>
      </div>
    </section>
  );
};

export default FoundersStory;
